<dgx-dfb-field-layout
  [id]="id"
  [legend]="field?.label?.text"
  [tooltip]="field?.tooltip"
  [hint]="field?.hint"
  [errorMessage]="errorMessage"
>
  <div
    class="radio"
    [ngClass]="field?.classes || []"
    [class.radio--inline]="field.inline"
  >
    <label *ngFor="let option of options">
      <input
        (change)="writeValue(option.value, true)"
        [checked]="value === option?.value"
        [disabled]="disabled"
        [name]="field?.controlName"
        [value]="option?.value"
        class="form-control"
        type="radio"
        [ngClass]="{
          'radiofield--large': $any(field)?.size === 'large'
        }"
      />
      <span>{{ option?.label }}</span>
    </label>
  </div>
</dgx-dfb-field-layout>
